<div [formGroup]="formArray.controls[group]" id="private-deals">
    <targeting-container label="PRIVATE DEALS" labelSectionWidth="280px" (onEdit)="openSidebar()" (onRemove)="reset()"
        [disabled]="isDisabled">
        <div *ngIf="selectionText.length !== 0" class="hide-chip-close-button">
            <span class="font-weight-bold mr-2">Deals: </span>
            <acl-ngx-tooltip [trigger]="trigger" [disabled]="!tooltipText.length" [text]="tooltipText.join(', ')">
            </acl-ngx-tooltip>
            <ng-template #trigger>
                <acl-ngx-chip [text]="selectionText" (click)="openSidebar()">
                </acl-ngx-chip>
            </ng-template>
        </div>
        <div *ngIf="selectionText.length == 0" class="font-italic py-1">
            <span (click)="openSidebar()" [ngClass]="isDisabled ? 'disabled' : 'cursor-pointer'">Select</span>
        </div>
    </targeting-container>
    <acl-ngx-flyout [open]="open" (close)="cancel()" large="true" portalRoot="private-deals">
        <acl-ngx-flyout-header title="Private Deals" (close)="cancel()">
        </acl-ngx-flyout-header>
        <acl-ngx-flyout-body>
            <browse-and-select [selectedTableNullStateText]="selectedTableNullStateText" [data]="currentPrivateDeals"
                [hidden]="!open" [preSelectedData]="preSelectedPrivateDeals" [hideSelectAllCheckbox]="true"
                [settings]="settings" (onDataChange)="onDataChange($event)" (onFilterChange)="onFilterChange($event)">
            </browse-and-select>
        </acl-ngx-flyout-body>
        <acl-ngx-flyout-footer [leftButton]="saveButton" [rightButton]="cancelButton"></acl-ngx-flyout-footer>
    </acl-ngx-flyout>
</div>